import { useThreatProfilesTokenClaims } from './useThreatProfilesTokenClaims'

export const useSelectedThreatProfileStorageKey = () => {
  const claims = useThreatProfilesTokenClaims()

  if (claims) {
    return `selectedThreatProfile/${claims.sub}/${claims.org}`
  }
}
